module.exports = __webpack_public_path__ + "media/assets_v3/images/user-panel/confirm-account-4f773c63118a78bfe61aa51946c66cd0.jpeg";